<template>
    <div class="container-fluid" >
        <div class="justify-content-between">
            <div><h3>Оюутан</h3></div>
            <div >
              <p>
            
                Түмэнцогт;Анужин;D1013021928;УЗ00272702
              </p>
              <div class="form-group">
                <textarea rows="10" v-model.trim="studentsText" class="form-control" placeholder="Оюутнуудын нарын мэдээлэл"/>
              </div>
           
              <button type="button" class="btn btn-primary" @click="addStudents">
                Оюутан нэмэх
              </button>
              <hr>
            </div>
        
        </div>
        <div class="card shadow my-4">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">Оюутнуудын жагсаалт</h6>
            </div>
            <div class="card-body">
                <div class="table-responsive" v-if="students!=null && students.length>0">
                    <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                        <thead>
                        <tr>
                            <th>№</th>
                            <th>Нэр</th>
                            <th>Овог</th>
                            <th>Оюутны код</th>
                            <th>Регистрийн дугаар</th>

                        </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(teacher, index) in students">
                                <td>{{index+1}}</td>
                                <td>{{teacher.name}}</td>
                                <td>{{teacher.lastname}}</td>
                                <td>{{teacher.code}}</td>
                                <td>{{teacher.register}}</td>

                            </tr>
                        
                        </tbody>
                    </table>
                </div>
                <div v-else class="alert alert-info text-center">Одоогоор оюутны мэдээлэл ороогүй байна.</div>
            </div>
        </div>

    </div>
    
</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'
    const fb = require('../../firebaseConfig.js')

    export default {
        data() {
            return {
               students:[],
               studentsText:null,
            }
        },
        computed: {
            ...mapState(['userProfile', 'currentUser'])
        },
        methods: {
            _getData(){
                fb.db.collection("students").orderBy('createdAt', 'desc').limit(50).onSnapshot(querySnapshot=> {
                    this.students=[];
                    querySnapshot.forEach(doc=> {
                        let object=doc.data()
                        object.id = doc.id
                        this.students.push(object);
                    });
                });
            },
            _edit(teacher){
                this.$router.push({ name: 'TeacherAdd', params: { teacherId: teacher.id} })
            },
            addStudents(){
                if(this.studentsText!=null && this.studentsText!=''){
                    var arrayOfLines = this.studentsText.match(/[^\r\n]+/g);


                    arrayOfLines.forEach(value=>{
                        var lineArray=value.split(";");

                        if(lineArray!=null && lineArray.length==4 && lineArray[2]!=null && lineArray[2]!='' && lineArray[3]!=null && lineArray[3]!=''){
                            var studentRef=fb.db.collection("students").doc(lineArray[2].toLowerCase()).get().then(studentData=>{

                                if(studentData!=null && studentData.exists){

                                }
                                else{
                                    fb.db.collection("students").where("register", "==", lineArray[3].toLowerCase()).get().then(value=>{
                                        if(value.empty){
                                            var studentDtail={
                                                'name':lineArray[1],
                                                'lastname': lineArray[0],
                                                'code':lineArray[2].toLowerCase(),
                                                'register': lineArray[3].toLowerCase(),
                                                'created': fb.usersCollection.doc(this.$store.getters.currentUser.uid),
                                                'createdAt': new Date()
                                            };
                                            studentData.ref.set(
                                                studentDtail
                                            );
                                            fb.db.collection("statistics").doc("studentcount").update({"count": fb.firestore.FieldValue.increment(1)});
                                        }
                                    });
                            
                                }
                                
                            });

                        }
                    });
                    this.studentsText='';
                    
                    }
            }

  
        },
        created() {
            this._getData();
                
        },

        filters: {
            formatDate(val) {
                if (!val) { return '-' }
                let date = val.toDate()
                return moment(date).fromNow()
            },
            trimLength(val) {
                if (val.length < 200) { return val }
                return `${val.substring(0, 200)}...`
            }
        }
    }
</script>
